(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-method-logos"] && !Shopify.designMode) return;
  try {
    class ProductMethodLogos extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll("[data-method-info-trigger]")];
    if (!this.triggers.length || this.events) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };

    this.addEventListener(
      "pointerover",
      (event) => {
        if (
          event.pointerType === "touch" ||
          !matchMedia("(hover: hover)").matches
        )
          return;
        clearTimeout(this.closeTimer);
        const trigger = event.target.closest("[data-method-info-trigger]");
        if (trigger && trigger !== this.dismissed) this.open(trigger);
      },
      options,
    );

    this.addEventListener(
      "pointerleave",
      () => {
        this.dismissed = null;
        this.closeTimer = setTimeout(() => {
          if (!this.pinned && document.activeElement !== this.activeTrigger)
            this.close();
        }, 150);
      },
      options,
    );

    this.addEventListener(
      "focusin",
      (event) => {
        const trigger = event.target.closest("[data-method-info-trigger]");
        if (trigger) this.open(trigger);
      },
      options,
    );

    this.addEventListener(
      "focusout",
      (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      },
      options,
    );

    this.addEventListener(
      "click",
      (event) => {
        const trigger = event.target.closest("[data-method-info-trigger]");
        if (!trigger) return;
        if (this.activeTrigger === trigger && this.pinned) {
          this.dismissed = trigger;
          this.close();
        } else {
          this.open(trigger);
          this.pinned = true;
        }
      },
      options,
    );

    document.addEventListener(
      "pointerdown",
      (event) => {
        if (!this.contains(event.target)) this.close();
      },
      options,
    );

    document.addEventListener(
      "keydown",
      (event) => {
        if (event.key !== "Escape" || !this.activeTrigger) return;
        event.preventDefault();
        this.dismissed = this.activeTrigger;
        this.close();
      },
      options,
    );

    window.addEventListener("resize", () => this.positionPanel(), options);
    document.addEventListener("scroll", () => this.positionPanel(), {
      ...options,
      capture: true,
      passive: true,
    });
  }

  open(trigger) {
    clearTimeout(this.closeTimer);
    if (this.activeTrigger === trigger) return;
    ProductMethodLogos.active?.close();
    this.activeTrigger = trigger;
    this.pinned = false;
    trigger.setAttribute("aria-expanded", "true");
    this.activePanel = this.querySelector(
      `#${CSS.escape(trigger.getAttribute("aria-controls"))}`,
    );
    this.activePanel.hidden = false;
    this.setAttribute("data-info-open", "");
    this.positionPanel();
    ProductMethodLogos.active = this;
  }

  positionPanel() {
    if (!this.activeTrigger || !this.activePanel) return;
    const gap = 10;
    const edge = 16;
    const viewportHeight = window.innerHeight;
    const viewportWidth = document.documentElement.clientWidth;
    const anchor = this.activeTrigger.getBoundingClientRect();
    const container = this.getBoundingClientRect();
    this.activePanel.style.maxHeight = `${viewportHeight - edge * 2}px`;
    const panel = this.activePanel.getBoundingClientRect();
    const left = Math.max(
      edge,
      Math.min(
        anchor.left + (anchor.width - panel.width) / 2,
        viewportWidth - panel.width - edge,
      ),
    );
    const above = anchor.top - panel.height - gap;
    const preferredTop = above >= edge ? above : anchor.bottom + gap;
    const top = Math.max(
      edge,
      Math.min(preferredTop, viewportHeight - panel.height - edge),
    );
    this.activePanel.style.left = `${left - container.left}px`;
    this.activePanel.style.top = `${top - container.top}px`;
    this.activePanel.dataset.placement =
      top + panel.height <= anchor.top ? "above" : "below";
    this.activePanel.style.setProperty(
      "--method-tooltip-arrow",
      `${Math.max(12, Math.min(anchor.left + anchor.width / 2 - left, panel.width - 12))}px`,
    );
  }

  close() {
    clearTimeout(this.closeTimer);
    if (this.activeTrigger) {
      this.activeTrigger.setAttribute("aria-expanded", "false");
      this.activePanel.hidden = true;
    }
    this.activeTrigger = null;
    this.activePanel = null;
    this.pinned = false;
    this.removeAttribute("data-info-open");
    if (ProductMethodLogos.active === this) ProductMethodLogos.active = null;
  }

  disconnectedCallback() {
    this.close();
    this.events?.abort();
    this.events = null;
  }
}

if (!customElements.get("product-method-logos")) {
  customElements.define("product-method-logos", ProductMethodLogos);
}
  } catch(e) { console.error(e); }
})();

})();
